@if (this.line() && themeControl && itemControl) {
  <div class="line-container flex-horizontal flex-center gap-8 width-100pc">
    <oui-select
      class="theme-select flex-1"
      [options]="themeOptions()"
      [control]="themeControl"></oui-select>
    <oui-select
      class="item-select flex-1"
      [options]="itemOptions()"
      [control]="itemControl"></oui-select>
    @if (builder()) {
      <oui-select
        class="operator-select flex-1"
        [options]="builder()!.operatorOptions"
        [control]="operatorControl"></oui-select>
      @switch (builder()!.inputType) {
        @case ('SelectMultiple') {
          <oui-select
            [placeholder]="builder()?.customPlaceholder || 'Valeur(s)'"
            class="value-select flex-1"
            [multiple]="true"
            [options]="(builder()!.options | async) || []"
            [control]="valueControl"></oui-select>
        }
        @case ('Select') {
          <oui-select
            [placeholder]="builder()?.customPlaceholder || 'Valeur'"
            class="value-select flex-1"
            [options]="(builder()!.options | async) || []"
            [control]="valueControl"></oui-select>
        }
        @case ('InputNumeric') {
          <oui-textfield
            [placeholder]="builder()?.customPlaceholder || 'Valeur'"
            class="value-input flex-1"
            type="number"
            [regexFilter]="numbersRegex"
            [control]="valueControl"></oui-textfield>
        }
        @case ('Age') {
          <oui-textfield
            [placeholder]="builder()?.customPlaceholder || 'Valeur'"
            class="value-input flex-1"
            maxlength="2"
            [regexFilter]="numbersRegex"
            textSuffix="ans"
            [control]="valueControl"></oui-textfield>
        }
        @case ('InputPercent') {
          <oui-textfield
            [placeholder]="builder()?.customPlaceholder || 'Valeur en pourcentage'"
            class="value-input flex-1"
            type="number"
            [control]="valueControl"
            textSuffix="%"></oui-textfield>
        }
        @case ('InputEuro') {
          <oui-textfield
            [placeholder]="builder()?.customPlaceholder || 'Valeur en euro'"
            class="value-input flex-1"
            type="number"
            [control]="valueControl"
            textSuffix="€"></oui-textfield>
        }
        @case ('Date') {
          <oui-date-picker
            class="value-input flex-1"
            [regexFilter]="numbersAndSeparatorsRegex"
            [control]="valueControl"
            placeholder="JJ/MM/AAAA">
          </oui-date-picker>
        }
        @case ('DateTime') {
          <oui-date-picker
            class="value-input flex-1"
            [regexFilter]="numbersAndSeparatorsRegex"
            [control]="valueControl"
            placeholder="JJ/MM/AAAA">
          </oui-date-picker>
        }
      }
    }
    <oui-button
      type="icon"
      color="secondary"
      (click)="removeLine()"
      ><oui-icon>delete</oui-icon></oui-button
    >
  </div>
}
